<div class="content">
  <div class="day" *ngFor="let day of dayArray | orderBy: ['dayNumber']"
       [ngClass]="{'weekend': day.isWeekend, 'holiday': day.isHoliday, 'today': day.isToday}">
    <div class="number">{{day.dayDisplay}}</div>
    <div class="of-week">{{day.dayOfWeek}}</div>
    <div class="text" *ngIf="day.text">{{day.text}}</div>
    <div class="indicator" *ngIf="!day.text"></div>
  </div>

</div>
